import { c as _c } from "react/compiler-runtime";
import React from "react";
interface ValidationErrorProps {
  error?: string | null | undefined;
  id?: string | undefined;
  className?: string | undefined;
}

/**
 * Component for displaying a validation error message with proper styling and accessibility
 */
const ValidationError: React.FC<ValidationErrorProps> = t0 => {
  const $ = _c(4);
  const {
    error,
    id,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  if (!error) {
    return null;
  }
  const t2 = `tw-text-red tw-text-xs tw-mt-1.5 tw-font-normal ${className}`;
  let t3;
  if ($[0] !== error || $[1] !== id || $[2] !== t2) {
    t3 = <div id={id} className={t2} role="alert" aria-live="polite">{error}</div>;
    $[0] = error;
    $[1] = id;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
export default React.memo(ValidationError);